import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge (injected by Emergent scripts or template)
(function removeEmergentBadge() {
  const remove = () => {
    document.querySelectorAll("#emergent-badge, a[href*='emergent-badge'], a[href*='app.emergent.sh']").forEach((el) => el.remove());
  };
  remove();
  if (document.body) {
    new MutationObserver(remove).observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener("DOMContentLoaded", () => { remove(); new MutationObserver(remove).observe(document.body, { childList: true, subtree: true }); });
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
